import { createStore } from "vuex";
/* 

使用仓库
import { useStore } from "vuex"
const store = useStore()

获取内容
store.getters.get_unreadCount

设置内容
store.commit('set_unreadCount',123)

*/
export default createStore({
  state: {
    unreadCount: 0,
  },
  getters: {
    get_unreadCount(state) {
      return state.unreadCount;
    },
  },
  mutations: {
    set_unreadCount(state, data) {
      state.unreadCount = data;
    },
  },
  actions: {},
  modules: {},
});
